import SkipForwardIcon from 'widget/components/SkipForwardButton/primitives/SkipForwardIcon';
import StyledSkipForwardButton from 'widget/components/SkipForwardButton/primitives/StyledSkipForwardButton';

type Props = {
  onClick: () => void;
  sizeToHide: string;
};

export default function SkipForwardButton({ onClick, sizeToHide }: Props) {
  return (
    <StyledSkipForwardButton
      aria-label="Skip forward 30 seconds"
      data-test="skip-forward-button"
      onClick={onClick}
      sizeToHide={sizeToHide}
      type="button"
    >
      <SkipForwardIcon />
    </StyledSkipForwardButton>
  );
}
